// Version : 0.0.1
// Author : VIGNESH
/* eslint-disable import/no-anonymous-default-export */
import AssignUserRightsTypes from './assign-users-rights.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	// Create User Control Rights Response
	createUserAssignControlRightsPageResponse: null,

	// Update User Control Rights Response
	updateUserAssignControlRightsPageResponse: null,

	// Save User Control Rights Response
	saveUserAssignControlRightsForAllPageResponse: null,

	// Fetch User Control Details Response
	fetchListUserControlDetailsResponse: null,

	// Fetch User Control Details List
	fetchListUserControlDetailsArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** CREATE USER ASSIGN CONTROL RIGHTS START *********************** */

		// create user assign control rights page success response
		case AssignUserRightsTypes.CREATE_USER_ASSIGN_CONTROL_RIGHTS_PAGE_SUCCESS:
			return { ...state, createUserAssignControlRightsPageResponse: action.payload };

		// create user assign control rights page failure response
		case AssignUserRightsTypes.CREATE_USER_ASSIGN_CONTROL_RIGHTS_PAGE_FAILURE:
			return { ...state, createUserAssignControlRightsPageResponse: action.payload };

		// create user assign control rights page response changed
		case AssignUserRightsTypes.CREATE_USER_ASSIGN_CONTROL_RIGHTS_PAGE_RESPONSE_CHANGED:
			return { ...state, createUserAssignControlRightsPageResponse: null };

		/** ***************** CREATE USER ASSIGN CONTROL RIGHTS END *********************** */

		/** ***************** UPDATE USER ASSIGN CONTROL RIGHTS START *********************** */

		// update user assign control rights page success response
		case AssignUserRightsTypes.UPDATE_USER_ASSIGN_CONTROL_RIGHTS_PAGE_SUCCESS:
			return { ...state, updateUserAssignControlRightsPageResponse: action.payload };

		// update user assign control rights page failure response
		case AssignUserRightsTypes.UPDATE_USER_ASSIGN_CONTROL_RIGHTS_PAGE_FAILURE:
			return { ...state, updateUserAssignControlRightsPageResponse: action.payload };

		// update user assign control rights page failure response changed
		case AssignUserRightsTypes.UPDATE_USER_ASSIGN_CONTROL_RIGHTS_PAGE_RESPONSE_CHANGED:
			return { ...state, updateUserAssignControlRightsPageResponse: null };

		/** ***************** UPDATE USER ASSIGN CONTROL RIGHTS END *********************** */

		/** ***************** SAVE USER ASSIGN CONTROL RIGHTS START *********************** */

		// save user assign control rights all page success response
		case AssignUserRightsTypes.SAVE_USER_ASSIGN_CONTROL_ALL_PAGE_SUCCESS:
			return { ...state, saveUserAssignControlRightsForAllPageResponse: action.payload };

		// save user assign control rights all page failure response
		case AssignUserRightsTypes.SAVE_USER_ASSIGN_CONTROL_ALL_PAGE_FAILURE:
			return { ...state, saveUserAssignControlRightsForAllPageResponse: action.payload };

		// save user assign control rights all page response changed
		case AssignUserRightsTypes.SAVE_USER_ASSIGN_CONTROL_ALL_PAGE_RESPONSE_CHANGED:
			return { ...state, saveUserAssignControlRightsForAllPageResponse: null };

		/** ***************** SAVE USER ASSIGN CONTROL RIGHTS START *********************** */

		/** ***************** FETCH USER CONTROL DETAILS START *********************** */

		// fetch list user assign control rights success response
		case AssignUserRightsTypes.FETCH_LIST_USER_CONTROL_DETAILS_SUCCESS:
			return {
				...state,
				fetchListUserControlDetailsResponse: action.payload,
				fetchListUserControlDetailsArr: docodeHexResponse(
					action.payload,
					'FetchUserControlDetailsKey',
				),
			};
		// fetch list user assign control rights failure response
		case AssignUserRightsTypes.FETCH_LIST_USER_CONTROL_DETAILS_FAILURE:
			return { ...state, fetchListUserControlDetailsResponse: action.payload };
		// fetch list user assign control rights response changed
		case AssignUserRightsTypes.FETCH_LIST_USER_CONTROL_DETAILS_RESPONSE_CHANGED:
			return { ...state, fetchListUserControlDetailsResponse: null };

		/** ***************** FETCH USER CONTROL DETAILS END *********************** */

		default:
			return state;
	}
};
